import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type Timeframe = "30d" | "60d" | "90d";

export interface CorrelationRow {
  timeframe: string;
  coin_a: string;
  coin_b: string;
  coin_a_symbol: string;
  coin_b_symbol: string;
  correlation: number;
  computed_at: string;
}

export interface UniverseCoin {
  coingecko_id: string;
  symbol: string;
  name: string;
  display_order: number;
  sector: string | null;
}

export function useAnalyticsUniverse() {
  return useQuery({
    queryKey: ["analytics-coin-universe"],
    queryFn: async (): Promise<UniverseCoin[]> => {
      const { data, error } = await supabase
        .from("analytics_coin_universe" as any)
        .select("coingecko_id, symbol, name, display_order, sector")
        .eq("is_active", true)
        .order("display_order");
      if (error) throw error;
      return ((data ?? []) as unknown) as UniverseCoin[];
    },
    staleTime: 60 * 60 * 1000,
  });
}

export function useCorrelationMatrix(timeframe: Timeframe) {
  return useQuery({
    queryKey: ["correlation-matrix", timeframe],
    queryFn: async (): Promise<CorrelationRow[]> => {
      const { data, error } = await supabase
        .from("correlation_matrix_data" as any)
        .select("*")
        .eq("timeframe", timeframe);
      if (error) throw error;
      return ((data ?? []) as any[]).map((r) => ({
        ...r,
        correlation: Number(r.correlation),
      })) as CorrelationRow[];
    },
    staleTime: 10 * 60 * 1000,
  });
}
